import { ProductionTab } from './tabs/ProductionTab';
import { FitmentTab } from './tabs/FitmentTab';
import { VisualInspectionTab } from './tabs/VisualInspectionTab';
import { AlignmentTab } from './tabs/AlignmentTab';

export interface TabConfig {
  id: string;
  label: string;
  component: React.ComponentType<any>;
}

export const tabConfig: TabConfig[] = [
  {
    id: 'production',
    label: 'Production Sheet',
    component: ProductionTab
  },
  {
    id: 'fitment',
    label: 'Fitment',
    component: FitmentTab
  },
  {
    id: 'visual',
    label: 'Visual Inspection',
    component: VisualInspectionTab
  },
  {
    id: 'alignment',
    label: 'Alignment',
    component: AlignmentTab
  }
]; 